export default __webpack_public_path__ + "static/media/avatar06.43c24b5c.svg";